import {Record, type RecordOf} from 'immutable';
import {type Box} from '@packages/utilities/box';

type ActiveUploadRecordShape = {
  progress: number;
  nodeClientRect: Box | null;
  error: boolean;
  isReplacement: boolean;
};

export const ActiveUploadRecord = Record({
  progress: 0,
  nodeClientRect: null,
  error: false,
  isReplacement: false,
});

export type ActiveUploadRecordType = RecordOf<ActiveUploadRecordShape>;
